<template>
  <div class="hcl-block-content-search-form" :class="{ 'form-invisible': !isFormVisible }"
    v-bind="attributesMeta(props.definition.meta)">
    <hcl-form :name="props.definition.meta.name" :parentMetaId="props.definition.meta.id"
      :definition="props.definition.form" :data="bucket" v-on:hcl-button-clicked="onButtonClicked"></hcl-form>

  </div>
</template>

<script setup lang="ts">
import { inject, provide } from 'vue'

import HclForm from '@/components/Form/Form.vue'

import { useMeta } from '@/composables/meta'

import { DefinitionBlockContentSearchForm, EventButtonClicked } from '@/components/types'

import { useDataStore } from '@/stores/data'
import { useStateStore } from '@/stores/state'

interface Props {
  /**
   * Definition as an JS object.
   */
  definition: DefinitionBlockContentSearchForm
}

const props = withDefaults(defineProps<Props>(), {
  definition: undefined
})

const { attributesMeta } = useMeta()

provide('blockContentMetaId', props.definition.meta.id)

const blockMetaId: string = inject('blockMetaId', '')

const { link } = useDataStore()

const bucket = link(props.definition.meta.id)

const { getBlockGroupNameValueWithDefault } = useStateStore()

const isFormVisible = getBlockGroupNameValueWithDefault(
  blockMetaId,
  'form',
  'visibility',
  true
)

const emit = defineEmits(['hcl-button-clicked'])

const onButtonClicked = (event: EventButtonClicked) => {
  emit('hcl-button-clicked', event)
}
</script>

<style lang="scss" scoped>
.hcl-block-content-search-form {
  &.form-invisible {
    display: none;
    visibility: hidden;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
